import { fb, validators, validatorHelper } from '../../../form';

const { createValidator } = validatorHelper;

export const digitsOnly = (value) => (value || '').toString().replace(/\D/g, '');

// 2-digit year; accepts "27" or "2027"
export const toTwoDigitYear = (value) => {
  const digits = digitsOnly(value);
  return digits.length === 4 ? digits.substring(2) : digits;
};

function isLuhnValid(number) {
  let sum = 0;
  let double = false;
  for (let i = number.length - 1; i >= 0; i--) {
    let d = parseInt(number.charAt(i), 10);
    if (double) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    double = !double;
  }
  return sum % 10 === 0;
}

function CardNumber(message = null) {
  return createValidator('card-number', message, null, function (control, e, validateOpt) {
    if (validateOpt.triggeredByChange && control.incomplete) return null;
    const digits = digitsOnly(control.value);
    if (!digits) return null;
    return digits.length >= 12 && digits.length <= 19 && isLuhnValid(digits) ? null : (message || 'Please check the card number.');
  });
}

function ExpiryMonth(message = null) {
  return createValidator('card-expiry-month', message, null, function (control, e, validateOpt) {
    if (validateOpt.triggeredByChange && control.incomplete) return null;
    const digits = digitsOnly(control.value);
    if (!digits) return null;
    const month = parseInt(digits, 10);
    return digits.length <= 2 && month >= 1 && month <= 12 ? null : (message || 'Expiry month should be 01 - 12.');
  });
}

function ExpiryYear(message = null) {
  return createValidator('card-expiry-year', message, null, function (control, e, validateOpt) {
    if (validateOpt.triggeredByChange && control.incomplete) return null;
    const raw = digitsOnly(control.value);
    if (!raw) return null;
    if (raw.length !== 2 && raw.length !== 4) return message || 'Expiry year should be 2 digits (YY).';

    // not expired (month is checked against the sibling control)
    const year = 2000 + parseInt(toTwoDigitYear(raw), 10);
    const monthControl = control.parent && control.parent.find('cardExpiryMM');
    const month = monthControl ? parseInt(digitsOnly(monthControl.value), 10) || 12 : 12;
    const now = new Date();
    const expired = year < now.getFullYear() || (year === now.getFullYear() && month < now.getMonth() + 1);
    return expired ? (message || 'The card has expired.') : null;
  });
}

function Cvv(message = null) {
  return createValidator('card-cvv', message, null, function (control, e, validateOpt) {
    if (validateOpt.triggeredByChange && control.incomplete) return null;
    const digits = digitsOnly(control.value);
    if (!digits) return null;
    return digits.length === 3 || digits.length === 4 ? null : (message || 'Security code should be 3 or 4 digits.');
  });
}

const numericAttrs = (autoComplete, maxLength) => ({ inputMode: 'numeric', autoComplete: autoComplete, maxLength: maxLength });

export function getEwayFormModel(data) {
  const model = fb.group({
    cardHolderName: [data.cardHolderName || '', [validators.Required()], { label: 'Name on Card', type: 'text', attrs: { autoComplete: 'cc-name' } }],
    cardNumber: [data.cardNumber || '', [validators.Required(), CardNumber()], { label: 'Card Number', type: 'text', attrs: numericAttrs('cc-number', 23) }],
    cardExpiryMM: [data.cardExpiryMM || '', [validators.Required(), ExpiryMonth()], { label: 'MM', type: 'text', attrs: numericAttrs('cc-exp-month', 2) }],
    cardExpiryYY: [data.cardExpiryYY || '', [validators.Required(), ExpiryYear()], { label: 'YY', type: 'text', attrs: numericAttrs('cc-exp-year', 4) }],
    securityCode: [data.securityCode || '', [validators.Required(), Cvv()], { label: 'CVV', type: 'text', attrs: numericAttrs('cc-csc', 4) }]
  });
  return model;
}
